import template from "./pCasemanSiteConfig.html";

export function pCasemanSiteConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanSiteConfigController,
    controllerAs: 'pCasemanSiteConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanSiteConfigController {
  constructor($scope, $location, $interval, Auth, Caseman, Notes, Sort, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.ConnectionQuality = ConnectionQuality;

    this.init();

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        this.Caseman.getSitesKlix().then(
          (success) => {
            this.sitesKlix = success.data.filter( site => site.name != "Iterators HQ").sort(this.Sort.abcBy("country"));
          },
          (error) => {
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  back() {
    window.history.back();
  }

  openConfigSite(site) {
    this.$location.path('/caseman/config/teams/' + site.id + '/name/' + site.name);
  }

}